export default __webpack_public_path__ + "static/img-employees-guide-cd36e018d24271d0bcd429f641e3f98b.jpg";